import {Socket} from 'ngx-socket-io';

export class FilesSocket extends Socket {
  constructor(public token: string, private url: string) {
    super({
      url, options: {
        autoConnect: false,
        withCredentials: true,
        extraHeaders: {
          authorization: `Bearer ${token}`
        },
        transportOptions: {
          polling: {
            extraHeaders: {
              authorization: `Bearer ${token}`
            }
          }
        }
      }
    });
  }
}
